import { modal, button } from '../common/Modal.js';
import { projectPublicResume } from '../../../../functions/shared/publicResume.mjs';
import { Resume } from '../../domain/models/Resume.js';
import { ResumePreview } from '../preview/ResumePreview.js';
import { StatsCalculator } from '../../domain/services/StatsCalculator.js';
import { PRDetector } from '../../domain/services/PRDetector.js';
export function showPublicSettings(resume, onSave) {
  const dialog = modal('Your public profile');
  const explanation = document.createElement('p');
  explanation.textContent = 'Choose what visitors can see. Highlights control the resume card; public race selection also controls the dashboard, totals and share image.';
  const scope = document.createElement('select'); scope.className = 'editor-input'; scope.setAttribute('aria-label', 'Public race selection');
  scope.add(new Option('All races', 'all')); scope.add(new Option('Only selected races', 'selected'));
  scope.value = resume.publicSettings?.scope || 'all';
  const check = (text, checked) => { const label = document.createElement('label'); const input = document.createElement('input'); input.type = 'checkbox'; input.checked = checked; label.append(input, document.createTextNode(text)); return { label, input }; };
  const notes = check('Show race notes', resume.publicSettings?.showNotes !== false);
  const locations = check('Show race locations and map', resume.publicSettings?.showLocations !== false);
  const choices = document.createElement('div');
  const selected = new Set(resume.publicSettings?.raceIds || []);
  const raceChoices = resume.races.map(r => { const c = check(`${r.raceName} · ${r.date || 'Date unknown'}`, selected.has(r.id)); choices.append(c.label); return { ...c, id: r.id }; });
  const visibility = () => { choices.hidden = scope.value !== 'selected'; }; scope.addEventListener('change', visibility); visibility();
  const settings = () => ({ scope: scope.value, showNotes: notes.input.checked, showLocations: locations.input.checked, raceIds: raceChoices.filter(c => c.input.checked).map(c => c.id) });
  const status = document.createElement('p'); status.setAttribute('role', 'status');
  const previewHost = document.createElement('div'); previewHost.className = 'workflow-preview';
  let preview;
  const view = () => {
    if (!preview) { preview = new ResumePreview({ idPrefix: 'visitor-' }); preview.render(previewHost); }
    const projected = Resume.fromFirestore(resume.id, projectPublicResume({ ...resume, publicSettings: settings() }));
    PRDetector.detect(projected.races);
    preview.update({ resume: projected, stats: StatsCalculator.calculate(projected.races), templateId: projected.templateId });
  };
  const save = button('Save public settings', async () => {
    save.disabled = true;
    try { await onSave(settings()); status.textContent = 'Saved. Published profiles update shortly.'; view(); }
    catch (error) { status.textContent = error.message || 'Could not save. Try again.'; }
    finally { save.disabled = false; }
  });
  dialog.append(explanation, scope, notes.label, locations.label, choices, button('Preview as a visitor', view), save, status, previewHost);
  dialog.addEventListener('close', () => preview?._dashboardView?.destroy?.());
}
